
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ModellingViewDialog extends Serenity.EntityDialog<ModellingViewRow, any> {
        protected getFormKey() { return ModellingViewForm.formKey; }
        protected getIdProperty() { return ModellingViewRow.idProperty; }
        protected getLocalTextPrefix() { return ModellingViewRow.localTextPrefix; }
        protected getNameProperty() { return ModellingViewRow.nameProperty; }
        protected getService() { return ModellingViewService.baseUrl; }

        protected form = new ModellingViewForm(this.idPrefix);

    }
}